import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { memo, useState, useMemo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import TabsContext from './contexts/TabsContext.js';
import useStateWithGetter from '../../hooks/useStateWithGetter.js';
import TabsContainer from './components/TabContainer.js';
import TabList from './components/TabList.js';

var Tabs = function Tabs(_ref) {
  var children = _ref.children,
    name = _ref.name,
    initialActiveTab = _ref.initialActiveTab,
    _ref$tabType = _ref.tabType,
    tabType = _ref$tabType === void 0 ? 'primary' : _ref$tabType,
    _ref$noVertical = _ref.noVertical,
    noVertical = _ref$noVertical === void 0 ? false : _ref$noVertical;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    tabs = _useState2[0],
    setTabs = _useState2[1];
  var _useStateWithGetter = useStateWithGetter(),
    _useStateWithGetter2 = _slicedToArray(_useStateWithGetter, 3),
    activeTab = _useStateWithGetter2[0],
    setActiveTab = _useStateWithGetter2[1],
    getActiveTab = _useStateWithGetter2[2];
  var register = function register(_name, tab) {
    if (!tabs[_name]) {
      setTabs(function (currTabs) {
        if (Object.keys(currTabs).length === 0) {
          setActiveTab(initialActiveTab || _name);
        }
        var newTabs = _objectSpread2({}, currTabs);
        newTabs[_name] = tab;
        return newTabs;
      });
    }
  };
  var deregister = function deregister(_name) {
    setTabs(function (currTabs) {
      var newTabs = _objectSpread2({}, currTabs);
      delete newTabs[_name];
      // Check if tab being removed is active tab
      if (_name === getActiveTab()) {
        // If so we need to select a new active tab
        // @ts-ignore
        var newActive = Object.keys(newTabs)
        // @ts-ignore
        .map(function (key) {
          return newTabs[key];
        })
        // @ts-ignore
        .sort(function (a, b) {
          return a.order - b.order;
        })[0];
        if (newActive) {
          setActiveTab(newActive.name);
        }
      }
      return newTabs;
    });
  };
  var value = useMemo(function () {
    return {
      activeTab: activeTab,
      tabType: tabType,
      noVertical: noVertical,
      deregister: deregister,
      register: register,
      setActiveTab: setActiveTab,
      setTabs: setTabs,
      tabs: tabs
    };
  }, [activeTab, tabType, noVertical, deregister, register, setActiveTab, setTabs, tabs]);
  var tabList = Object.keys(tabs).map(function (key) {
    return tabs[key];
  }).sort(function (a, b) {
    return a.order - b.order;
  });
  return /*#__PURE__*/React.createElement(TabsContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(TabsContainer, null, /*#__PURE__*/React.createElement(TabList, {
    name: name,
    tabs: tabList
  }), children));
};
var _TabContainer = withDefaultTheme(/*#__PURE__*/memo(Tabs));

export default _TabContainer;
